import { ButtonGroup } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import { moment } from 'src/common/types';
import { PerformanceChartInterval, StrategyDashboardParameters } from '../store/types';
import WO2Button from './../../../../common/components/button/Button';

interface Props {
  parameters: StrategyDashboardParameters;
  intervalButtonClicked: (button: IIntervalButton) => void;
}

export interface IIntervalButton {
  name: PerformanceChartInterval;
  startDate: moment;
  enabled: boolean;
}

const MonthlyPerformanceChartButtons = (props: Props): JSX.Element => {
  const inceptionDate = '2000-01-01T00:00:00Z';

  const getStartDate = (months: number) => {
    return DateTime.now().minus({ months: months }).minus({ days: 1 });
  };

  const getClassName = (button: IIntervalButton, intervalName?: PerformanceChartInterval) => {
    return intervalName === button.name ? 'Mui-disabled' : '';
  };

  const isButtonEnabled = (months: number) => {
    const startDate = getStartDate(months);
    return inceptionDate ? DateTime.fromISO(inceptionDate) < startDate : true;
  };

  const buttons: IIntervalButton[] = [
    {
      name: PerformanceChartInterval.OneMonth,
      startDate: getStartDate(1).toISODate(),
      enabled: isButtonEnabled(1),
    },
    {
      name: PerformanceChartInterval.ThreeMonths,
      startDate: getStartDate(3).toISODate(),
      enabled: isButtonEnabled(3),
    },
    {
      name: PerformanceChartInterval.SixMonths,
      startDate: getStartDate(6).toISODate(),
      enabled: isButtonEnabled(6),
    },
    {
      name: PerformanceChartInterval.OneYear,
      startDate: getStartDate(12).toISODate(),
      enabled: isButtonEnabled(12),
    },
    {
      name: PerformanceChartInterval.ThreeYears,
      startDate: getStartDate(36).toISODate(),
      enabled: isButtonEnabled(36),
    },
    {
      name: PerformanceChartInterval.Inception,
      startDate: inceptionDate,
      enabled: true,
    },
  ];

  return (
    <ButtonGroup disableElevation variant="text" style={{ display: 'flex', justifyContent: 'center' }}>
      {buttons.map((button, index) => (
        <WO2Button
          key={`button-${index}`}
          style={{
            width: '70px',
          }}
          variant="text"
          disableElevation
          onClick={() => {
            props.intervalButtonClicked(button);
          }}
          className={`${getClassName(button, props.parameters.performanceChartStartDate.interval)} SemiTransparent`}
        >
          {button.name}
        </WO2Button>
      ))}
    </ButtonGroup>
  );
};

export default MonthlyPerformanceChartButtons;
